module.exports = __webpack_public_path__ + "media/birthday_tier_4-2cc6b79399353640e3a0c7866460b89d.mp3";